export default __webpack_public_path__ + "static/media/time-to-use-latest-technology-for-creating-a-website.2b8a1fe1.md";